<template>
    <!-- TEMPLATE FOR LEFT NAVIGATION PAGE -->
    <!-- Limit to 2 content only so that can be easily copied -->
    <div class="page-content mt-4">
        <pre>Reference : module/penyu/page-left-nav.vue</pre>
        <breadcrumb class="bg-light pl-0" :items="breadcrumbs" />
        <h1 class="mx-0">Page with left navigation</h1>

        <div class="card side-tab">
            <div class="card-body">
                <div class="tab-body row">
                    <div class="col-md-2 tabs">
                        <div class="nav-scrollable">
                            <div
                                class="text"
                                v-for="item in navigations"
                                :key="item.code"
                                :class="{ active: activeTab === item.code }"
                                @click="activeTab = item.code"
                            >
                                {{ item.label }}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-10 details">
                        <div v-if="activeTab == 'part1'">
                            <div class="title">
                                List inside tab
                            </div>
                            <div class="details">
                                <!-- EXAMPLE OF LIST -->
                                <table-simple></table-simple>
                            </div>
                        </div>
                        <div v-if="activeTab == 'part2'">
                            <div class="title">
                                Green Toggle
                            </div>
                            <div class="details">
                                <!-- EXAMPLE OF GREEN TOGGLE / CHECKBOX -->
                                <div
                                    class="green-toggle custom-control custom-switch my-2"
                                >
                                    <input
                                        type="checkbox"
                                        class="custom-control-input"
                                        id="this-toggle-option"
                                        v-model="greenToggle"
                                        :value="greenToggle"
                                    />
                                    <label
                                        class="custom-control-label"
                                        for="this-toggle-option"
                                    >
                                        Green Toggle
                                    </label>
                                    <div>
                                        This is the description area for the
                                        toggle
                                    </div>
                                </div>
                                <!-- END OF GREEN TOGGLE -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    components: {
        TableSimple: () => import("@/components/penyu/table-simple.vue"),
        Breadcrumb: () => import("@/components/commons/breadcrumb.vue")
    },
    data() {
        return {
            activeTab: "part1",
            navigations: [
                { label: "List", code: "part1" },
                { label: "Toggle", code: "part2" }
            ],
            greenToggle: true,
            breadcrumbs: [
                {
                    text: "Penyu",
                    to: {
                        name: "penyu"
                    }
                },
                {
                    text: "Page with left navigation",
                    to: ""
                }
            ]
        };
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {}
};
</script>
